import { Affix, Drawer, Layout } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation, Outlet } from "react-router-dom";
import Sidenav from "../Sidenav/Sidenav";
import Footer from "./Footer";
import Header from "./Header";
import styles from "./Main.module.css";
import QuickLinks from "./QuickLinks";
import checkTokenExp from "../../utils/checkTokenExp";
import jwtDecode from "jwt-decode";

const { Header: AntHeader, Content, Sider } = Layout;

function Main() {
  const token = localStorage.getItem("access-token");

  useEffect(() => {
    if (token) {
      checkTokenExp(token);
      jwtDecode(token);
      // You can use id if needed
    }
  }, [token]);

  const [collapsed, setCollapsed] = useState(false);
  const [visible, setVisible] = useState(false);
  const [placement, setPlacement] = useState("right");
  const [sidenavColor, setSidenavColor] = useState("#1890ff");
  const [fixed, setFixed] = useState(false);
  const [sideNavOpenKeys, setSideNavOpenKeys] = useState("");

  const handleCollapsed = (val) => setCollapsed(val);
  const openDrawer = () => setVisible(!visible);
  const handleSidenavColor = (color) => setSidenavColor(color);
  const handleFixedNavbar = (type) => setFixed(type);

  const location = useLocation();
  let { pathname } = location;
  pathname = pathname.replace("/", " ").trim();
  const pathArr = pathname.split("/");

  const isLogged = Boolean(localStorage.getItem("isLogged"));

  const sideNavOpenKeysHandler = (val) => setSideNavOpenKeys(val);

  useEffect(() => {
    if (pathname === "rtl") setPlacement("left");
    else setPlacement("right");
  }, [pathname]);

  if (!isLogged) {
    return <Outlet />; // For login/register pages
  }

  return (
    <Layout className={styles.mainLayout} style={{ minHeight: "100vh" }}>
      {/* SIDEBAR */}
      {isLogged && (
        <>
          {/* Drawer for small screens */}
          <Drawer
            title={false}
            placement={placement === "right" ? "left" : "right"}
            closable={false}
            onClose={() => setVisible(false)}
            visible={visible}
            width={220}
          >
            <Sider trigger={null} width={220} theme="light" className={styles.siderDrawer}>
              <Sidenav color={sidenavColor} sideNavOpenKeys={sideNavOpenKeys} />
            </Sider>
          </Drawer>

          {/* Normal sidebar */}
          <Sider
            breakpoint="lg"
            collapsible
            collapsed={collapsed}
            width={220}
            theme="light"
            className={`${styles.siderMain} scrollbar-hide`}
          >
            {!collapsed && (
              <div>
                <h2 className="text-white text-center mt-2 mb-1" style={{ fontSize: "25px" }}>
                  
                  <strong style={{ color: "#6ECCAF", fontWeight: "bold" }}>Up2date</strong>
                </h2>
              </div>
            )}
            <Sidenav color={sidenavColor} sideNavOpenKeys={sideNavOpenKeys} />
          </Sider>
        </>
      )}

      {/* MAIN CONTENT */}
      <Layout
        className={
          collapsed
            ? styles.mainLayoutUncollapse
            : styles.mainLayoutCollapse
        }
      >
        {/* HEADER */}
        {fixed ? (
          <Affix>
            <AntHeader>
              <Header
                onPress={openDrawer}
                name={pathname}
                subName={pathname}
                handleSidenavColor={handleSidenavColor}
                handleFixedNavbar={handleFixedNavbar}
                collapsed={collapsed}
                handleCollapsed={handleCollapsed}
                isLogged={isLogged}
              />
            </AntHeader>
          </Affix>
        ) : (
          <AntHeader>
            <Header
              onPress={openDrawer}
              name={pathname}
              subName={pathname}
              handleSidenavColor={handleSidenavColor}
              handleFixedNavbar={handleFixedNavbar}
              collapsed={collapsed}
              handleCollapsed={handleCollapsed}
              isLogged={isLogged}
            />
          </AntHeader>
        )}

        {/* QUICK LINKS */}
        {isLogged && (pathname === "dashboard" || pathname === "") && (
          <QuickLinks
            sideNavOpenKeys={sideNavOpenKeys}
            sideNavOpenKeysHandler={sideNavOpenKeysHandler}
          />
        )}

        {/* CONTENT */}
        <Content style={{ margin: "24px", background: "#fff", padding: "24px", minHeight: 280 }}>
          <Outlet />
        </Content>

        {/* FOOTER */}
        <Footer />
      </Layout>
    </Layout>
  );
}

export default Main;